module.exports = __webpack_public_path__ + "static/kiwok-arsredovisning-18e55ba194bba215c405b073c14ee485.pdf";